export function useCommon() {
  /**
   * 存储隐私号
   * 接收参数（floorId, phone）,存在cookie中
   * 有效时间为 10 分钟
   */
  const setSecretFloorPhone = (floorId: number, phone: string) => {
    const expiresDate = new Date()
    // 计算 10 分钟后的时间
    expiresDate.setMinutes(expiresDate.getMinutes() + 10)
    useCookie(`${floorId}_SecretFloorPhone`, { expires: expiresDate }).value = `${phone}_${expiresDate.getTime()}`
  }

  /**
   * 获取隐私号
   * 接收参数（floorId），计算剩余秒数，返回{  phone, countdown }
   */
  const getSecretFloorPhone = (floorId: number) => {
    return new Promise((resolve) => {
      if (!floorId || !useCookie(`${floorId}_SecretFloorPhone`).value) {
        return resolve(false)
      }
      else {
        const phone = useCookie(`${floorId}_SecretFloorPhone`).value as string
        const val = phone.split('_')
        const endTime = Number(val[1])
        const countdown = endTime - Date.now()
        return resolve({ phone: val[0], countdown })
      }
    })
  }

  /**
   * 一个定时执行方法的函数
   */
  const countDown = (callback: () => void, time: number = 600 * 1000) => {
    setTimeout(() => {
      callback()
    }, time)
  }

  return {
    setSecretFloorPhone,
    getSecretFloorPhone,
    countDown,
  }
}
